/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';

Blockly.Blocks.createc_colon_lights = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/Colon.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_COLON_LIGHTS_EFFECT);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_COLON_LIGHTS_EFFECT_TRANSITION, '0'],
        [Blockly.Msg.LANG_COLON_LIGHTS_EFFECT_FIXED, '1'],
        [Blockly.Msg.LANG_COLON_LIGHTS_EFFECT_ATTENUATION, '2'],
      ]), 'STAT');
    this.appendDummyInput().appendField(Blockly.Msg.LANG_COLON_LIGHTS).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_COLON_LIGHTS_TOOLTIP);
  },
};

Blockly.Blocks.createc_colon_lights_off = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/Colon.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_COLON_LIGHTS_OFF);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_COLON_LIGHTS_OFF_TOOLTIP);
  },
};

Blockly.Blocks.createc_obelisco_lights = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/Obelisco.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('COLOUR')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL2)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('').appendField(Blockly.Msg.LANG_OBELISCO_LIGHTS).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_OBELISCO_LIGHTS_TOOLTIP);
  },
};

Blockly.Blocks.createc_obelisco_lights_off = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/Obelisco.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_OBELISCO_LIGHTS_OFF);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_OBELISCO_LIGHTS_OFF_TOOLTIP);
  },
};

Blockly.Blocks.createc_obelisco_luminaria_zona5 = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/LuzCalle.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_SALIDAS_LED_ON, 'HIGH'],
        [Blockly.Msg.LANG_SALIDAS_LED_OFF, 'LOW'],
      ]), 'STAT');
    this.appendDummyInput().appendField(Blockly.Msg.LANG_LUMINARIA_ZONA5).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_LUMINARIA_ZONA5_TOOLTIP);
  },
};

Blockly.Blocks.createc_obelisco_screen = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/matriz_9_de_julio.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_OBELISCO_SCREEN_MESSAGE_SHOW);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_OBELISCO_SCREEN_MESSAGE_0, '0'],
        [Blockly.Msg.LANG_OBELISCO_SCREEN_MESSAGE_1, '1'],
        [Blockly.Msg.LANG_OBELISCO_SCREEN_MESSAGE_2, '2'],
        [Blockly.Msg.LANG_OBELISCO_SCREEN_MESSAGE_3, '3'],
      ]), 'STAT');
    this.appendDummyInput('').appendField(Blockly.Msg.LANG_OBELISCO_SCREEN).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_OBELISCO_SCREEN_TOOLTIP);
  },
};
